import { memo } from "react";

import {
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useDispatch } from "react-redux";

import { CircularProggressIndicator } from "../components-atoms/CircularProggressIndicator";

import { ShopRegionHeadline } from "../components-atoms";
import { useHistory } from "react-router";

import { BannerCard } from "../components-molecules";
import { rankDownBanner, rankUpBanner } from "../redux/actions/getBanners";
import up_arrow from "../assets/icons/up_arrow.svg";
import down_arrow from "../assets/icons/down_arrow.svg";
interface IProps {
  loading?: boolean;
  data: Array<any>;
  sortType?: number;
  bottomTextCreator: any;
  topTextCreator: any;
  pathCreator?: any;
  threeDotMenuItems?: Array<any>;
  imagePreviewCreator?: Function;
}
export const BannersList = memo((props: IProps) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    loading,
    data,
    bottomTextCreator,
    topTextCreator,
    pathCreator,
    imagePreviewCreator,
  } = props;

  return (
    <Container className={classes.component}>
      {loading ? (
        <CircularProggressIndicator />
      ) : data.length === 0 ? (
        <Container className={classes.noRecordsFound}>
          <Typography variant="body1" component="span">
            No records found
          </Typography>
        </Container>
      ) : (
        <>
          {data &&
            data.length > 0 &&
            data.map((item: any, index: any) => (
              <div key={index}>
                {item?.[1]?.length > 0 && (
                  <ShopRegionHeadline
                    key={index}
                    headlineTypeSingular="Banner"
                    headLineTypePlural="Banners"
                    data={{
                      header: index === 0 ? "Published" : "Unpublished",
                      count: item[1].length,
                    }}
                  />
                )}
                {item?.[1] &&
                  item?.[1].map((item: any, index: number) => (
                    <BannerCard
                      type="shop"
                      key={index}
                      data={{
                        ...item,
                        bottomText: bottomTextCreator
                          ? bottomTextCreator(item)
                          : "",
                        topText: topTextCreator(item),
                      }}
                      onClick={() => {
                        pathCreator && history.push(pathCreator(item));
                      }}
                      cardImage={() => (
                        <img
                          className={classes.cardImage}
                          alt="Card"
                          src={imagePreviewCreator && imagePreviewCreator(item)}
                          width="200"
                          height="120"
                        ></img>
                      )}
                    >
                      <BannerCard.EndArea>
                        <Grid container>
                          <Grid
                            item
                            xs={6}
                            className={classes.centerWrapperArea}
                          >
                            <span
                              className={classes.statusText}
                              style={{
                                color: item?.Published ? "green" : "red",
                              }}
                            >
                              {item?.Published ? "Published" : "Unpublished"}
                            </span>
                          </Grid>
                          <Grid
                            item
                            xs={5}
                            style={{ textAlign: "center" }}
                            className={classes.centerWrapperArea}
                          >
                            <Typography
                              className={classes.centerText}
                              variant="body2"
                              component="span"
                              color="textSecondary"
                            >
                              {item?.Published
                                ? `Position ${
                                    item?.Published ? `${item.RankNo}` : ""
                                  }`
                                : `Unlisted`}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={1}
                            style={{ textAlign: "right", alignItems: "start" }}
                            direction="column"
                          >
                            <Grid item xs={6}>
                              <Button
                                style={{ justifyContent: "start" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(rankUpBanner(item.Id));
                                }}
                              >
                                <img alt="up_arrow" src={up_arrow}></img>
                              </Button>
                            </Grid>
                            <Grid item xs={6}>
                              <Button
                                style={{ justifyContent: "start" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(rankDownBanner(item.Id));
                                }}
                              >
                                <img alt="down_arrow" src={down_arrow}></img>
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </BannerCard.EndArea>
                    </BannerCard>
                  ))}
              </div>
            ))}
        </>
      )}
    </Container>
  );
});
const useStyles = makeStyles({
  component: {
    display: "flex",
    flexDirection: "column",
  },
  noRecordsFound: {
    display: "flex",
    paddingLeft: "24px",
  },
  threeDot: {
    width: 100,
    height: 100,
    backgroundImage: "radial-gradient(circle, black 10px, transparent 11px)",
    backgroundSize: "100% 33.33%",
  },
  cardImage: {
    borderRadius: 5,
    marginRight: 15,
  },
  statusText: {
    fontWeight: "bold",
    display: "inline-block",
    verticalAlign: "middle",
  },
  centerText: { display: "inline-block", verticalAlign: "middle" },
  centerWrapperArea: { display: "flex", alignItems: "center" },
});
